export default __webpack_public_path__ + "static/media/app-receitas2.be52d435.png";